<div class="container">
  <div class="text-center">
    <h5 class="display-5 mt-3 mb-5">My Appointments</h5>
  </div>

  <hr>

  <div class="my-5" *ngIf="isAppointmentsLoading == true" style="width: 100%; display: flex; align-items: center; justify-content: center;">
    <div class="loader"></div>
    <div>
      Loading Appointments...
    </div>
  </div>

  <div *ngIf="isAppointmentsLoading == false">
    <a
    *ngFor="let appointment of appointmentList"
    style="cursor: pointer;"
    data-toggle="modal"
    data-target="#appointmentDetailsModal"
    (click)="onSelectAppointment(appointment._id, appointment.serviceData[0].title)">
    <div class="appointment text-center p-3 mb-3">
      <div class="row">
        <div class="col-md-4" style="font-weight: 550;">
          {{ appointment.fullName }}
        </div>
        <div class="col-md-4">
          {{ appointment.serviceData[0].title }}
        </div>
        <div class="col-md-4">
          {{ appointment.createdAt | date: 'dd MMM yyyy, hh:MM a' }}
        </div>
      </div>
    </div>
  </a>
  </div>

</div>

<!-- Details Modal -->
<div class="modal fade" id="appointmentDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ selectedAppointment.fullName }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5" style="text-align: right;">
            <p style="font-weight: bold;">Name:</p>
          </div>
          <div class="col-7">
            <p>{{ selectedAppointment.fullName }}</p>
          </div>

          <div class="col-5" style="text-align: right;">
            <p style="font-weight: bold;">Email:</p>
          </div>
          <div class="col-7">
            <p>{{ selectedAppointment.email }}</p>
          </div>

          <div class="col-5" style="text-align: right;">
            <p style="font-weight: bold;">Service:</p>
          </div>
          <div class="col-7">
            <p>{{ selectedServiceName }}</p>
          </div>

          <div class="col-5" style="text-align: right;">
            <p style="font-weight: bold;">Date:</p>
          </div>
          <div class="col-7">
            <p>{{ selectedAppointment.createdAt | date: 'dd MMM yyyy, hh:MM a' }}</p>
          </div>

          <div class="col-5" style="text-align: right;">
            <p style="font-weight: bold;">Amount Paid:</p>
          </div>
          <div class="col-7">
            <p>$ {{ selectedAppointment.paymentAmount }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
